import {Action} from '@ngrx/store';
import {EligibilityAndAvailabilityDTO} from '@staff-app/models/EligibilityAndAvailabilityDTO';

export enum EligibilityAndAvailabilityActionTypes {
  GetEligibilityAndAvailability = '[EligibilityAndAvailability] Get Eligibility And Availability',
  GetEligibilityAndAvailabilitySuccessful = '[EligibilityAndAvailability] Get Eligibility And Availability Successful',
  SaveEligibilityAndAvailability = '[EligibilityAndAvailability] Save Eligibility And Availability',
  SaveEligibilityAndAvailabilitySuccessful = '[EligibilityAndAvailability] Save Eligibility And Availability Successful',
  NavigateAway = '[EligibilityAndAvailability] Navigate Away'
}

export class GetEligibilityAndAvailability implements Action {
  readonly type =
    EligibilityAndAvailabilityActionTypes.GetEligibilityAndAvailability;

  constructor(public payload: number) {} // userID
}
export class GetEligibilityAndAvailabilitySuccessful implements Action {
  readonly type =
    EligibilityAndAvailabilityActionTypes.GetEligibilityAndAvailabilitySuccessful;

  constructor(public payload: EligibilityAndAvailabilityDTO) {}
}

export class SaveEligibilityAndAvailability implements Action {
  readonly type =
    EligibilityAndAvailabilityActionTypes.SaveEligibilityAndAvailability;

  constructor(
    public payload: EligibilityAndAvailabilityDTO,
    public isEditMode = false
  ) {}
}
export class SaveEligibilityAndAvailabilitySuccessful implements Action {
  readonly type =
    EligibilityAndAvailabilityActionTypes.SaveEligibilityAndAvailabilitySuccessful;

  constructor(public payload: number[]) {}
}
export class NavigateAway implements Action {
  readonly type = EligibilityAndAvailabilityActionTypes.NavigateAway;

  constructor() {}
}
export type EligibilityAndAvailabilityActions =
  | GetEligibilityAndAvailability
  | GetEligibilityAndAvailabilitySuccessful
  | SaveEligibilityAndAvailability
  | SaveEligibilityAndAvailabilitySuccessful
  | NavigateAway;
